import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AssetTypeTranslationPipe } from '../../pipes/asset-type-translation/asset-type-translation.pipe';
import { AssetsDetailViewRoutingModule } from './assets-detail-view-routing.module';

@NgModule({
  imports: [CommonModule, AssetsDetailViewRoutingModule, AssetTypeTranslationPipe],
})
export class ClientAssetsDetailViewModule {}
